import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-129" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-130" data-mp="1o3dj01a9xtlv">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-50 ring-1 ring-blue-100" data-id="element-131" data-mp="2223kru81ghgk">
          <ShieldCheckIcon className="h-8 w-8 text-blue-600" aria-hidden="true" data-id="element-132" data-mp="1x54trkjo8qml" />
        </span>

        <h2 className="mt-7 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-133" data-mp="19f0mn379y8qu">
          Garanzia di 7 giorni
        </h2>

        <p className="mt-6 text-lg text-slate-900 md:text-xl" data-id="element-134" data-mp="1j4txu33i8luk">
          Prova l'Atlante senza rischi. Se entro 7 giorni ritieni che il materiale non faccia per
          te, puoi richiedere il rimborso.
        </p>
        <p className="mt-4 text-blue-900/70" data-id="element-135" data-mp="qn7wrhni53nc">
          Se non fa per te, non vogliamo che tu perda i tuoi soldi.
        </p>
      </div>
    </section>;
}